import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { VacationBody } from '../entities/vacation-body';
import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import { Observable } from 'rxjs/Observable';
import { tap } from 'rxjs/operators';

@Injectable()
export class VacationBodyService extends BaseCrudService<VacationBody> {

  public uri = '/api/vacationBody/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance VacationBodyService');
  }

  buildSentence(entity?: VacationBody, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.row ?
          `row${QueryOperator.Contain}${entity.row}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isRprog ?
          `isRprog${QueryOperator.Equal}${entity.isRprog}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.status ?
          `status${QueryOperator.Equal}${entity.status}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.usedDays ?
          `usedDays${QueryOperator.Contain}${entity.usedDays}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity.absenceLeave && entity.absenceLeave.id) {
        query = query.concat(
          `absenceLeave.id${QueryOperator.Equal}${entity.absenceLeave.id}${QueryOperator.Split}`
        );
      }
      if (entity.vacationHead && entity.vacationHead.id) {
        query = query.concat(
          `vacationHead.id${QueryOperator.Equal}${entity.vacationHead.id}${QueryOperator.Split}`
        );
      }
      if (entity.vacationType && entity.vacationType.code) {
        query = query.concat(
          `vacationType.code${QueryOperator.Equal}${entity.vacationType.code}${QueryOperator.Split}`
        );
      }
      if (entity.absenceLeave && entity.absenceLeave.state.code) {
        if(entity.absenceLeave.state.code !== '00'){
          query = query.concat(
            `absenceLeave.state.code${QueryOperator.Equal}${entity.absenceLeave.state.code}${QueryOperator.Split}`
          );
        }
      }
     //console.log(query);
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }

    this.httpParams = this.httpParams.set(QueryOperator.SortParam, 'absenceLeave.checkOutTime');
    return this.httpParams;
  }

  // search(entity?: VacationBody, event?: LazyLoadEvent): Observable<ResponsePageable<VacationBody>> {
  //  //console.log('ENTRA A BUSCAR BODY1');
  //   const url = `${this.rutaServidor}${this.uri}`;
  //   this.spinnerService.showAll();
  //   const httpParams = this.buildSentence(entity, event);
  //  //console.log('ENTRA A BUSCAR BODY2');
  //   return this.httpClient.get<ResponsePageable<VacationBody>>(url, { params: httpParams })
  //      .pipe(
  //        tap(response => {
  //        //console.log('response de VacationBody - Check Here');
  //        //console.log(response);
  //         return response;
  //       })
  //     );
  // }
}



// WEBPACK FOOTER //
// ./src/app/core/services/vacation-body.service.ts